import React from 'react';
import { NavItem } from 'reactstrap';

export default function Link({ linkTo, linkIcon, title, forMobile = false }) {
  // since the placeListings url contains query params.
  // react router doesnt interpret query params.
  // link would not be active.
  linkTo = linkTo.includes('?') ? linkTo.split('?')[0] : linkTo;
  return (
    <NavItem>
      <a href={linkTo} className="nav-link" aria-label={title}>
        {title && <span className="d-none d-lg-block">{title}</span>}
        <div className="d-block d-lg-none mobile-icon">
          <img src={`https://s3.amazonaws.com/honeyguide/assets/icons/${linkIcon}`} alt="" />
          <p>{title}</p>
        </div>
      </a>
    </NavItem>
  );
}



// WEBPACK FOOTER //
// ./src/components/TopBar/Link.jsx